import { usePathname } from "next/navigation";
import Script from "next/script";
import { ReactNode, useEffect } from "react";
import { useGlobalLoading } from "../../contexts/Loading";
import { useModal } from "../../contexts/ModalContext";
import { classNames } from "../../helpers/index";
import Footer from "./Footer";
import Header from "./Header";
// import TrainingComponent from "./TrainingComponent";
import { useSidebarContext } from "@/contexts/SidebarContext";
import { cn } from "@/lib/utils";
import Link from "next/link";
import { useRouter } from "next/router";
import UpgradePlanModal from "../common/UpgradePlanModal";
import GoogleAnalytics from "../GA";
import Loader from "../Loader";
import { Dialog, DialogContent } from "../ui/dialog";
import SideBar from "./Sidebar";

interface LayoutProps {
  meta?: ReactNode;
  header?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  className?: string;
  trainingComponent?: ReactNode;
  IdeasStream?: ReactNode;
  hideRiskWarning?: boolean;
  hideSpaceWhenNoRiskWarning?: boolean;
  hideIdeastream?: boolean;
  hideHeader?: boolean;
  hideSidebar?: boolean;
  onScrollBg?: boolean;
  showDisabled?: boolean;
}

export default function Layout(props: LayoutProps) {
  const modal = useModal();
  const router = useRouter();
  const globalLoading = useGlobalLoading();
  const { showSidebar } = useSidebarContext();
  const pathname: string | null = usePathname();
  const { showDisabled = false } = props;
  // console.log("pathname",typeof pathname);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user-info")!);
    if (user) {
      // loadIntercom({
      //   appId: "iw1axg8d",
      //   user_hash: user.hmac,
      //   user_id: user.user_id,
      //   email: user.user.email,
      //   name: user.user.first_name + " " + user.user.last_name,
      //   ssr: false,
      //   initWindow: true,
      //   custom_launcher_selector: "#intercom-custom",
      //   delay: 0,
      // });
      // initIntercomWindow({
      //   appId: "iw1axg8d",
      //   email: user.user.email,
      //   user_hash: user.hmac,
      //   user_id: user.user_id,
      // });
    }
  }, []);
  return (
    <>
      {/* <div className={classNames('antialiased w-full flex flex-col !bg-background text-white h-[100vh] overflow-hidden ',props.className)}> */}
      {globalLoading.loading ? (
        <div className="!h-[100vh] !w-full flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <div
          className={classNames(
            "antialiased w-full h-full flex flex-col loading-container ",
            globalLoading.loading ? "h-[100vh] overflow-hidden " : "",
            props.className
          )}
        >
          <div className="relative h-0 -z-10">
            <span
              className="absolute invisible"
              style={{ fontFamily: `"Shoika"` }}
            >
              &nbsp;
            </span>
          </div>
          {/* {globalLoading.loading || true&& (
          <div className="z-[999999]">
            <Loader />
          </div>
        )} */}
          {/* <div className={"transitions-all duration-300 dark:bg-blue20 dark:bg-stars main-load "+(modal.open?'blur-sm':'')}> */}
          <div
            className={
              "transitions-all flex flex-col gap-1 duration-300 dark:bg-blue20 main-load h-full" +
              (modal.open ? "blur-sm" : "")
            }
          >
            {props.meta}
            {typeof props.header !== "undefined" ? (
              props.header
            ) : props?.hideHeader ? (
              // @ts-ignore
              <Header
                hideHeader={props?.hideHeader}
                onScrollBg={props?.onScrollBg}
                showDisabled={props?.showDisabled}
              />
            ) : (
              // @ts-ignore
              <Header showDisabled={props?.showDisabled} />
            )}

            <div className="flex  w-full h-full">
              {!props.hideSidebar && (
                <div className={""}>
                  <SideBar showDisabled={props?.showDisabled} />
                </div>
              )}
              <div
                className={cn(
                  "w-full min-h-[calc(100vh-135px)]  lg:min-h-[calc(100vh-140px)] xl:min-h-[calc(100vh-105px)] flex-grow overflow-auto", //  h-[calc(100vh-190px)] lg:h-[calc(100vh-134px)]  xl:h-[calc(100vh-100px)]
                  // "w-full h-[calc(100vh)] lg:h-[calc(100vh)]  xl:h-[calc(100vh)]",
                  router.pathname?.includes("logout") ? "!w-full" : "",
                  showSidebar
                    ? "md:w-[calc(100%-250px)]"
                    : "md:w-[calc(100%-70px)]",
                  props.hideSidebar ? "!w-full !h-full" : ""
                )}
              >
                {props.children}
                {/* {props.hideRiskWarning ? (
                  props.hideSpaceWhenNoRiskWarning ? (
                    ""
                  ) : (
                    <div className="my-12"></div>
                  )
                ) : (
                  <RiskWarnings />
                )} */}
              </div>
            </div>
            <div className="p-3 bg-foreground text-primary-foreground text-xs absolute bottom-0 w-full hidden">
              New - Join the{" "}
              <Link
                href={`/creator-program?locale=${router.query.locale || "en"}`}
                className="underline font-bold"
              >
                Strategy Creator Program
              </Link>{" "}
              and turn your trading ideas into profit-generating strategies
            </div>
            {
              typeof props.trainingComponent !== "undefined"
                ? props.trainingComponent
                : ""
              // <TrainingComponent />
            }
            {typeof props.footer !== "undefined" ? props.footer : <Footer />}
          </div>
          <div id="intercom-custom"></div>
          <Dialog open={modal.open}>
            <DialogContent>{modal.body}</DialogContent>
          </Dialog>
        </div>
      )}
      <UpgradePlanModal />
      <GoogleAnalytics GA_TRACKING_ID={"G-NRPKERR6KT"} />
      {/* <Script
        id="socket-streamer"
        type="module"
        src="/scripts/socket_streamer.js"
        strategy="afterInteractive"
        onLoad={() => {}}
      ></Script> */}
    </>
  );
}
